module.exports = __webpack_public_path__ + "static/media/image.5801b538.svg";